import { render, staticRenderFns } from "./themeScream.vue?vue&type=template&id=ceb073b8&scoped=true&"
import script from "./themeScream.vue?vue&type=script&lang=js&"
export * from "./themeScream.vue?vue&type=script&lang=js&"
import style0 from "./themeScream.vue?vue&type=style&index=0&id=ceb073b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb073b8",
  null
  
)

export default component.exports